const check = (value: string): boolean => {
  value = value.toLowerCase();
  return value === "application/pdf" || value === "pdf";
};

export default (file: File | string): boolean => {
  if (typeof file === "string") {
    return check(file);
  }

  return check(file.type);
};
